import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Glossary = () => {
    const data = [
        {
            title: "NC",
            text: ["One Non-Conformity (NC) is counted on each day for each crew where any regime violation occured"],
        },
        {
            title: "NC/vessel/month",
            text: [
                "Average number of individual days where a violation occured per vessel and per month. To calculate this, we get the total number of NC for all crew across the selected fleet for the period, divided by number of vessels and the number of months.",
            ],
        },
        {
            title: "Ranks",
            text: [
                'Ranks stats are grouped under "industry-generic" rank names. The data for the ranks in your fleet would be compared with the closest matching industry rank names. To get the most accurate stats comparison, it is advised to use names as similar as possible to the industry labels.',
            ],
        },
        {
            title: "Port visits",
            text: [
                "A port visit is counted each time a vessel enters the highlighted area and stays in the area for at least 4 hours",
            ],
        },
        {
            title: "NC / visit",
            text: [
                "A Non-Conformity is counted for each day for any individual crew member when any regime violation occurred whilst the vessel was in port (see port visits)",
                "The NC/visit average is calculated by dividing the total number of Non-Conformities at this location by the number of port visits registered at the location for the period across the selected vessels.",
            ],
        },
        {
            title: "Crew Complement",
            text: [
                "Latest crew count for each vessel as of their latest synchronisation",
                "This number only counts active service terms on the day of the synchronisation. It excludes all the trainee / apprentice ranks. It also excludes any crew who hasn't entered their hours over the past 30 days as Watchkeeper would assume that this crew is no longer on board.",
            ],
        },
        {
            title: "Industry Data",
            text: [
                "Aggregated metrics across the industry, which is made of the Watchkeeper (10000+ vessels, 200K + seafarers). The data is anonymised and aggregated to only keep metrics applicable to a class of vessels: Bulk carriers, Container ships, Tankers, etc.",
            ],
        },
        {
            title: "Routine operations",
            text: [
                'All activities defined in Watchkeeper which are not classified in the category "Other operation" or "Other routine operation"',
            ],
        },
        {
            title: "Overriding operations",
            text: ['Any activity classified in Watchkeeper in the category "Other operation" or "Other routine operation"'],
        },
    ];
    const items = data.map((item, index) => (_jsxs("li", { className: "list-group-item", children: [_jsx("h3", { children: item.title }), _jsx("span", { children: item.text.map((line, lineIndex) => (_jsxs("span", { children: [line, _jsx("br", {})] }, lineIndex))) })] }, index)));
    return (_jsx("div", { className: "row", children: _jsx("div", { className: "col-12", children: _jsx("ul", { className: "col-12 list-group list-group-flush", children: items }) }) }));
};
